<template>
  <div class="share-model func-btn" v-if="value">
    <div class="content func-btn">
      <p class="title func-btn">如何分享</p>
      <div class="context func-btn">
        <div class="text func-btn">
          <p class="step step1 func-btn"></p>
          <p class="desc func-btn">点击右上角「…」</p>
          <p class="step step2 func-btn"></p>
          <p class="desc func-btn">将本书发给好友或分享朋友圈</p>
        </div>
        <img src="../../assets/images/pop-img-share2.png" class="func-btn" />
      </div>
    </div>
    <img class="close-btn func-btn" src="../../assets/images/close.png" @click="$emit('input', false)">
  </div>
</template>

<script>
export default {
  name: 'ShareModel',
  props: {
    value: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../styles/mixins.scss";
  .share-model {
    position: fixed;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(4, 4, 15, 0.4);
    .close-btn {
      width: 62px;
      height: 62px;
      margin: 212px auto 0;
    }
    .content {
      background: #fff;
      border-radius: 26px;
      margin: 20vh auto 0;
      width: 552px;
      padding: 50px 63px 70px;
    }
    .title {
      font-size: 38px;
      line-height: 1;
      color: #333;
      font-weight: bold;
      text-align: center;
    }
    .context {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: 50px;
      img {
        width: 296px;
        margin-right: -30px;
      }
    }
    .text {
      width: 256px;
    }
    .step {
      display: block;
      width: 110px;
      height: 40px;
    }
    .step1 {
      background: url('../../assets/images/pop-icon-step1.png') no-repeat center / 100% 100%;
    }
    .step2 {
      background: url('../../assets/images/pop-icon-step2.png') no-repeat center / 100% 100%;
    }
    .desc {
      font-size: 32px;
      line-height: 46px;
      color: #666;
      padding-top: 17px;
      padding-bottom: 24px;
    }
  }
</style>
